import React, { useEffect, useState } from "react";
import { Button, Col, Row, FormGroup, CustomInput } from "reactstrap";
import swal from "@sweetalert/with-react";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";
import { baseurl } from "../../../../baseurl";
import { GetIp } from "../../ShortCutComponents/Get_ip";
import ResponseLoader from "../../ShortCutComponents/ResponseLoader";
import NayyerSheet from "../../../Features/Imports/assets/NayyerSheet.xlsx";
import { csvFileToArray } from "../../../Features/Imports/data";
import { checkPermission } from "../../../../Helper";

export default function InvoiceExcelLoad(props) {
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");

  const [loadingResponce, setLoadingResponce] = useState(false);
  const [goodRows, setGoodRows] = useState([]);
  const [badRows, setBadRows] = useState([]);
  const [showBadRows, setShowBadRows] = useState(false);
  const [file, setfile] = useState(null);
  const [disableField, setDisableField] = useState(true);
  const [ipCountry, setIpCountry] = useState({ userIp: "", userCountry: "" });
  const [percentageLoader, setpercentageLoader] = useState(false);
  const [showQty, setShowQty] = useState(false);

  useEffect(() => {
    const funCall = async (value) => {
      const openModalCheck = await asyncRollCheck(value);
    };
    funCall(1);
    getIpCountry();
  }, []);
  const asyncRollCheck = async (value) => {
    let pathname = "/invoiceExcelLoad";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  const handleOnChange = (event) => {
    setfile(event.target.files[0]);
  };
  const handleOnChangeFile = async () => {
    if (!file) {
      swal({
        title: "File Not Selected!",
        text: "Please Select File",
        icon: "warning",
      });
      return;
    }

    try {
      setLoadingResponce(true);
      const jsonData = await csvFileToArray(file); 
      const nonEmptyArrays = jsonData.filter((arr) => arr.length > 0);

      if (nonEmptyArrays.length === 0) {
        throw new Error("The file contains no valid data");
      }
      const headers = nonEmptyArrays[0];
      const Invoice = new Map();
      nonEmptyArrays.slice(1).forEach((row) => {
        const invoiceNo = row[0];
        const hasMasterData = row[1]?.trim() || row[2]?.trim();
        if (hasMasterData) {
          const master = {}; 
          headers.slice(0, 10).forEach((key, index) => { 
            master[key] = row[index];
          });

          const detail = {};
          headers.slice(10, 22).forEach((key, index) => { 
            detail[key] = row[index + 10];
          });
          const hasDetailData =
            detail.Item_name?.trim() !== "" || detail.Item_code?.trim() !== "";
          Invoice.set(invoiceNo, {
            master,
            details: hasDetailData ? [detail] : [],
          });
        } else {
          const existinginvoice = Invoice.get(invoiceNo);
          if (existinginvoice) {
            const detail = {};
            headers.slice(9, 21).forEach((key, index) => {
              detail[key] = row[index + 9];
            });

            const hasDetailData =
              detail.Item_name?.trim() !== "" ||
              detail.Item_code?.trim() !== "";

            if (hasDetailData) {
              existinginvoice.details.push(detail);
            }
          }
        }
      });

      const processedData = Array.from(Invoice.values());
      if (!processedData.length) {
        throw new Error("No data found in the file");
      }
      console.log("processedData", processedData);
      const firstItem = processedData[0];
      if (!firstItem.master || Object.keys(firstItem.master).length === 0) {
        throw new Error("The file contains no valid master data");
      }

      const hasDetails = processedData.some(
        (item) =>
          item.details?.length > 0 ||
          item.details[0].Item_name ||
          item.details[0].Item_code
      );

      if (!hasDetails) {
        throw new Error("The file contains no valid detail data");
      }
      setDisableField(false);
      await verifyExcelData(processedData);
    } catch (error) {
      setLoadingResponce(false);
      console.error("Error processing file:", error);
      swal({
        title: "Error",
        text: error.message || "Failed to process file",
        icon: "error",
      });
    }
  };
  // Fix the verifyExcelData function
  const verifyExcelData = async (data) => {
    if (!data || data.length === 0) {
      swal({
        title: "Error",
        text: "No data to verify",
        icon: "error",
      });
      return;
    }

    setpercentageLoader(true);
    const companyId = localStorage.getItem("companyId");
    const currentDate = new Date();
    const date = moment(currentDate).format("YYYY-MM-DD");

    try {
      const { userIp, userCountry } = ipCountry;

      const response = await axios.post(
        `${baseurl}/invoice/verifyInvoiceExcelData`,
        {
          companyId,
          excelData: data,
          date,
          username: username,
          userIp,
          userCountry,
        },
        {
          headers: {
            authorization: token,
          },
        }
      );
      const responseData = response.data.data || [];

      const isInvalidValue = (value) => {
        return (
          value === null ||
          value === undefined ||
          value === "" ||
          value === "Invalid" ||
          (typeof value === "string" && value.trim() === "")
        );
      };

      const groupedGoodRows = [];
      const groupedBadRows = [];

      responseData.forEach((item, index) => {
        const master = item.master || {};
        const details = item.details || [];
        const inputMaster = data[index]?.master || {};
        const inputDetails = data[index]?.details || [];

        // Master data validation
        const isMasterDataValid =
          !isInvalidValue(inputMaster.invoiceNo) &&
          !isInvalidValue(inputMaster.CUSTOMER_CODE) &&
          !isInvalidValue(inputMaster.CUSTOMER_NAME) &&
          !isInvalidValue(inputMaster.DATE) &&
          !isInvalidValue(inputMaster.ITAX_FILER);

        // Check master result
        const masterResult = master.result?.[0] || {};
        const hasValidCustomer =
          (masterResult.CUSTOMER_CODE_id &&
            masterResult.CUSTOMER_CODE_id !== "null" &&
            masterResult.CUSTOMER_CODE_id !== "more than one") ||
          (masterResult.CUSTOMER_NAME_id &&
            masterResult.CUSTOMER_NAME_id !== "null" &&
            masterResult.CUSTOMER_NAME_id !== "more than one");

        const hasValidFiler =
          (masterResult.ITAX_FILER_id &&
            masterResult.ITAX_FILER_id !== "null" &&
            masterResult.ITAX_FILER_id !== "more than one") ||
          (masterResult.ITAX_FILER_RATE &&
            masterResult.ITAX_FILER_RATE !== "null" &&
            masterResult.ITAX_FILER_RATE !== "more than one");

        const masterValid =
          isMasterDataValid && hasValidCustomer && hasValidFiler;

        // Details validation
        let detailsValid = true;
        const areDetailsDataValid = inputDetails.every(
          (detail) =>
            !isInvalidValue(detail?.QTY) && !isInvalidValue(detail?.RATE)
        );

        // Check each detail
        details.forEach((detail, i) => {
          const detailResult = detail.result?.[0] || {};

          // Check if detail has required data
          const hasDetailData =
            !isInvalidValue(inputDetails[i]?.Item_code) ||
            !isInvalidValue(inputDetails[i]?.Item_name);

          if (hasDetailData) {
            // Check if detail is valid
            const itemValid =
              detailResult.item_id &&
              detailResult.item_id !== "null" &&
              detailResult.item_id !== "more than one";

            const UOMvalid =
              detailResult.UOM_id &&
              detailResult.UOM_id !== "null" &&
              detailResult.UOM_id !== "more than one";

            const StaxValid =
              detailResult.STAX_GROUP_ID &&
              detailResult.STAX_GROUP_ID !== "null" &&
              detailResult.STAX_GROUP_ID !== "more than one";

            // All required fields should be valid for the detail
            if (!(itemValid && UOMvalid && StaxValid)) {
              detailsValid = false;
            }
          }
        });

        // Format the row
        const formattedDetails = inputDetails.map((detail, i) => ({
          Item_code: detail?.Item_code || "Invalid",
          Item_name: detail?.Item_name || "Invalid",
          UOM: detail?.UOM || "Invalid",
          QTY: detail?.QTY
            ? String(detail?.QTY).replace(/,/g, "")
            : detail?.QTY || "Invalid",
          RATE: detail?.RATE
            ? String(detail?.RATE).replace(/,/g, "")
            : detail?.RATE || "Invalid",
          AMOUNT_EXCLUDING_SALES_TAX: detail?.AMOUNT_EXCLUDING_SALES_TAX
            ? String(detail?.AMOUNT_EXCLUDING_SALES_TAX).replace(/,/g, "")
            : detail?.AMOUNT_EXCLUDING_SALES_TAX || "Invalid",
          SALES_TAX_RATE: detail?.SALES_TAX_RATE
            ? String(detail?.SALES_TAX_RATE).replace(/%/g, "")
            : detail?.SALES_TAX_RATE || "Invalid",
          SALES_TAX_AMOUNT: detail?.SALES_TAX_AMOUNT
            ? String(detail?.SALES_TAX_AMOUNT).replace(/,/g, "")
            : detail?.SALES_TAX_AMOUNT || "Invalid",
          AMOUNT_INCLUDING_SALES_TAX: detail?.AMOUNT_INCLUDING_SALES_TAX
            ? String(detail?.AMOUNT_INCLUDING_SALES_TAX).replace(/,/g, "")
            : detail?.AMOUNT_INCLUDING_SALES_TAX || "Invalid",
          FURTHER_TAX_RATE: detail?.FURTHER_TAX_RATE
            ? String(detail?.FURTHER_TAX_RATE).replace(/%/g, "")
            : detail?.FURTHER_TAX_RATE || "Invalid",
          FURTHER_TAX_AMOUNT: detail?.FURTHER_TAX_AMOUNT
            ? String(detail?.FURTHER_TAX_AMOUNT).replace(/,/g, "")
            : detail?.FURTHER_TAX_AMOUNT || "Invalid",
          TOTAL_INCLUDING_TAXES: detail?.TOTAL_INCLUDING_TAXES
            ? String(detail?.TOTAL_INCLUDING_TAXES).replace(/,/g, "")
            : detail?.TOTAL_INCLUDING_TAXES || "Invalid",
          ITEM_ID:
            details[i]?.result?.[0]?.item_id ||
            details[i]?.result?.[0]?.code ||
            "Invalid",
          UOM_ID: details[i]?.result?.[0]?.UOM_id || "Invalid",
          STAX_GROUP_ID: details[i]?.result?.[0]?.STAX_GROUP_ID || "Invalid",
        }));

        const formattedRow = {
          master: {
            invoiceNo: inputMaster.invoiceNo || "Invalid",
            CUSTOMER_CODE: inputMaster.CUSTOMER_CODE || "Invalid",
            CUSTOMER_NAME: inputMaster.CUSTOMER_NAME || "Invalid",
            DATE: inputMaster.DATE || "Invalid",
            DUE_DATE: inputMaster.DUE_DATE || "Invalid",
            SALES_TAX_STATUS: inputMaster.SALES_TAX_STATUS || "Invalid",
            Note: inputMaster.Note || "Invalid",
            ITAX_FILER: inputMaster.ITAX_FILER || "Invalid",
            ITAX_RATE_US_236_H: inputMaster.ITAX_RATE_US_236_H
              ? String(inputMaster?.ITAX_RATE_US_236_H).replace(/%/g, "")
              : inputMaster?.ITAX_RATE_US_236_H || "Invalid",
            INCOME_TAX_US_236_H: inputMaster.INCOME_TAX_US_236_H
              ? String(inputMaster.INCOME_TAX_US_236_H).replace(/,/g, "")
              : inputMaster.INCOME_TAX_US_236_H || "Invalid",
            CUSTOMER_id:
              masterResult.CUSTOMER_CODE_id ||
              masterResult.CUSTOMER_NAME_id ||
              "Invalid",
            ITAX_FILER_id: masterResult.ITAX_FILER_id || "Invalid",
            ITAX_FILER_RATE: masterResult.ITAX_FILER_RATE || "Invalid",
          },
          details: formattedDetails,
        };
        console.log("formattedRow", formattedRow);
        // Classify as good or bad row
        if (masterValid && detailsValid && areDetailsDataValid) {
          groupedGoodRows.push(formattedRow);
        } else {
          groupedBadRows.push(formattedRow);
        }
      });

      setLoadingResponce(false);
      setpercentageLoader(false);
      setGoodRows(groupedGoodRows);
      setBadRows(groupedBadRows);
      setShowQty(true);

      swal({
        title: "Done",
        text: `Excel verification completed. ${groupedGoodRows.length} valid rows, ${groupedBadRows.length} invalid rows.`,
        icon: "success",
      });
    } catch (error) {
      console.error("Error in verifyExcelData:", error);
      setLoadingResponce(false);
      setpercentageLoader(false);

      swal({
        title: "Error",
        text:
          error.response?.data?.message ||
          "Something went wrong, try to refresh the page and try again.",
        icon: "error",
      });
    }
  };

  const getUserIp = async function () {
    let res = await GetIp();
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };

  const getIpCountry = async () => {
    let { userIp, userCountry } = await getUserIp();
    setIpCountry({ userIp, userCountry });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingResponce(true);
    var companyId = localStorage.getItem("companyId");

    let { userIp, userCountry } = ipCountry;
    axios
      .post(
        `${baseurl}/invoice/addImportinvoiceData`,
        {
          companyId,
          invoice: goodRows,
          username: username,
          userIp,
          userCountry,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (res) {
        setLoadingResponce(false);
        swal({
          title: "Saved Successfully!",
          text: "Invoice Added",
          icon: "success",
        }).then((value) => {});
      })
      .catch(function (error) {
        console.log("erooor", error);
        setLoadingResponce(false);

        swal({
          title: "Error",
          text: "Something went wrong, try to refresh the page and try again.",
          icon: "error",
        });
      });
  };
  const headers = [
    "Invoice No",
    "CUSTOMER CODE",
    "CUSTOMER NAME",
    "DATE",
    "DUE DATE",
    "SALES TAX STATUS",
    "Note",
    "I.TAX FILER",
    "I.TAX RATE U/S 236 H",
    "INCOME TAX U/S 236 H",
    "Customer ID",
    "Itax Filter Id",
    "Itax Filter Rate",
    "Item code",
    "Item name",
    "UOM",
    "QTY",
    "RATE",
    "AMOUNT EXCLUDING SALES TAX",
    "SALES TAX RATE",
    "SALES TAX AMOUNT",
    "AMOUNT INCLUDING SALES TAX",
    "FURTHER TAX RATE",
    "FURTHER TAX AMOUNT",
    "TOTAL INCLUDING TAXES",
    "Item Id",
    "UOM ID",
    "STAX GROUP ID",
  ];

  return (
    <>
      {loadingResponce ? (
        <ResponseLoader percentage={percentageLoader} />
      ) : percentageLoader ? (
        <ResponseLoader percentage={percentageLoader} />
      ) : (
        <div>
          <Row className="Creative-Invoice-header-styling">
            <Col xs="6" className="card-header-Creative-Invoice">
              <>
                <strong>
                  <h4>Import Invoice Sheet</h4>
                </strong>
              </>
            </Col>
            <Col xs="6" className="card-header-Creative-Invoice">
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Link
                  to="/OverviewInvoice"
                  style={{
                    fontFamily: "Times New Roman",
                    fontWeight: "normal",
                    margin: "10px",
                  }}
                >
                  <u className="Back-to-Overview">Back to Overview</u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-chevron-left mx-2 icon-color"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </div>
            </Col>
          </Row>
          <div className="mt-3">
            <div className="row">
              <div className="col-4 mt-1">
                <a href={NayyerSheet} download>
                  Download example CSV
                </a>
              </div>
            </div>
            <FormGroup>
              <div className="row">
                <div className="col-11">
                  <CustomInput
                    type="file"
                    id="exampleCustomFileBrowser"
                    name="customFile"
                    accept=".csv,.xlsx"
                    required
                    onChange={handleOnChange}
                  />
                </div>
                <div className="col-1">
                  <span className="d-flex flex-row-reverse">
                    <Button
                      className="mr-1 btn-outline-primary"
                      onClick={handleOnChangeFile}
                    >
                      Import
                    </Button>
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-3">
                  <span className="">
                    <Button
                      hidden={goodRows.length === 0 && badRows.length === 0}
                      className={`mr-1 mt-1 ${
                        showBadRows
                          ? "btn-outline-success"
                          : "btn-outline-danger"
                      }`}
                      onClick={() => setShowBadRows(!showBadRows)}
                    >
                      Show {showBadRows ? "Good" : "Bad"} Rows
                    </Button>
                  </span>
                </div>
                {showQty ? (
                  <div className="col-4 mt-2">
                    <span style={{ color: "green" }}>
                      No of Good Rows : {goodRows.length}
                    </span>{" "}
                    &
                    <span className="ml-2" style={{ color: "red" }}>
                      No of Bad Rows : {badRows.length}
                    </span>
                  </div>
                ) : null}
              </div>
            </FormGroup>

            <div style={{ overflowX: "auto" }}>
              <table className="table">
                <thead>
                  {showQty ? (
                    <tr>
                      {headers.map((header, index) => (
                        <th
                          style={{
                            border: "1px solid black",
                          }}
                          key={index}
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  ) : null}
                </thead>
                <tbody>
                  {showBadRows
                    ? badRows.map((row, rowIndex) => (
                        <React.Fragment key={rowIndex}>
                          {row.details.map((detail, detailIndex) => (
                            <tr key={`${rowIndex}-${detailIndex}`}>
                              {detailIndex === 0 ? (
                                <>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.invoiceNo === "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.invoiceNo}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.CUSTOMER_id === "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.CUSTOMER_CODE}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.CUSTOMER_id === "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.CUSTOMER_NAME}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.DATE === "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.DATE}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.DUE_DATE === "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.DUE_DATE}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.SALES_TAX_STATUS ===
                                        "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.SALES_TAX_STATUS}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    
                                  >
                                    {row.master.Note}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.ITAX_FILER_id === "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.ITAX_FILER}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.ITAX_RATE_US_236_H ===
                                        "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.ITAX_RATE_US_236_H}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.INCOME_TAX_US_236_H ===
                                        "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.INCOME_TAX_US_236_H}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.CUSTOMER_id === "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.CUSTOMER_id}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.ITAX_FILER_id === "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.ITAX_FILER_id}
                                  </td>
                                  <td
                                    rowSpan={row.details.length}
                                    style={{
                                      backgroundColor:
                                        row.master.ITAX_FILER_RATE === "Invalid"
                                          ? "#FF0000"
                                          : "transparent",
                                    }}
                                  >
                                    {row.master.ITAX_FILER_RATE}
                                  </td>
                                </>
                              ) : null}
                              <td
                                style={{
                                  backgroundColor:
                                    detail.ITEM_ID === "Invalid" ||
                                    detail.ITEM_ID === "null" ||
                                    detail.ITEM_ID === "more than one"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.Item_code}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.ITEM_ID === "Invalid" ||
                                    detail.ITEM_ID === "null" ||
                                    detail.ITEM_ID === "more than one"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.Item_name}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.UOM_ID === "Invalid" ||
                                    detail.UOM_ID === "null" ||
                                    detail.UOM_ID === "more than one"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.UOM}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.QTY === "Invalid"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.QTY}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.RATE === "Invalid"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.RATE}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.AMOUNT_EXCLUDING_SALES_TAX ===
                                    "Invalid"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.AMOUNT_EXCLUDING_SALES_TAX}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.STAX_GROUP_ID === "Invalid" ||
                                    detail.STAX_GROUP_ID === "null" ||
                                    detail.STAX_GROUP_ID === "more than one"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.SALES_TAX_RATE}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.SALES_TAX_AMOUNT === "Invalid"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.SALES_TAX_AMOUNT}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.AMOUNT_INCLUDING_SALES_TAX ===
                                    "Invalid"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.AMOUNT_INCLUDING_SALES_TAX}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.FURTHER_TAX_RATE === "Invalid"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.FURTHER_TAX_RATE}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.FURTHER_TAX_AMOUNT === "Invalid"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.FURTHER_TAX_AMOUNT}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.TOTAL_INCLUDING_TAXES === "Invalid"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.TOTAL_INCLUDING_TAXES}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.ITEM_ID === "Invalid" ||
                                    detail.ITEM_ID === "null" ||
                                    detail.ITEM_ID === "more than one"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.ITEM_ID}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.UOM_ID === "Invalid" ||
                                    detail.UOM_ID === "null" ||
                                    detail.UOM_ID === "more than one"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.UOM_ID}
                              </td>
                              <td
                                style={{
                                  backgroundColor:
                                    detail.STAX_GROUP_ID === "Invalid" ||
                                    detail.STAX_GROUP_ID === "null" ||
                                    detail.STAX_GROUP_ID === "more than one"
                                      ? "#FF0000"
                                      : "transparent",
                                }}
                              >
                                {detail.STAX_GROUP_ID}
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      ))
                    : goodRows.map((row, rowIndex) => (
                        <React.Fragment key={rowIndex}>
                          {row.details.map((detail, detailIndex) => (
                            <tr key={`${rowIndex}-${detailIndex}`}>
                              {detailIndex === 0 ? (
                                <>
                                  <td rowSpan={row.details.length}>
                                    {row.master.invoiceNo}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.CUSTOMER_CODE}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.CUSTOMER_NAME}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.DATE}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.DUE_DATE}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.SALES_TAX_STATUS}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.Note}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.ITAX_FILER}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.ITAX_RATE_US_236_H}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.INCOME_TAX_US_236_H}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.CUSTOMER_id}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.ITAX_FILER_id}
                                  </td>
                                  <td rowSpan={row.details.length}>
                                    {row.master.ITAX_FILER_RATE}
                                  </td>
                                </>
                              ) : null}
                              <td>{detail.Item_code}</td>
                              <td>{detail.Item_name}</td>
                              <td>{detail.UOM}</td>
                              <td>{detail.QTY}</td>
                              <td>{detail.RATE}</td>
                              <td>{detail.AMOUNT_EXCLUDING_SALES_TAX}</td>
                              <td>{detail.SALES_TAX_RATE}</td>
                              <td>{detail.SALES_TAX_AMOUNT}</td>
                              <td>{detail.AMOUNT_INCLUDING_SALES_TAX}</td>
                              <td>{detail.FURTHER_TAX_RATE}</td>
                              <td>{detail.FURTHER_TAX_AMOUNT}</td>
                              <td>{detail.TOTAL_INCLUDING_TAXES}</td>
                              <td>{detail.ITEM_ID}</td>
                              <td>{detail.UOM_ID}</td>
                              <td>{detail.STAX_GROUP_ID}</td>
                            </tr>
                          ))}
                        </React.Fragment>
                      ))}
                </tbody>
              </table>
            </div>
            <hr
              style={{
                border: "1px solid",
                marginBottom: "3vh",
                marginTop: "1vh",
                borderColor: "#E4E5E6",
              }}
            />
            <div className="col-md-12 d-flex flex-row-reverse">
              <FormGroup>
                <Button
                  onClick={handleSubmit}
                  className="mr-1 invoiceSubmitButton"
                  disabled={goodRows.length === 0}
                >
                  Save Changes
                </Button>
                <Link
                  to={{
                    pathname: "/OverviewInvoice",
                  }}
                >
                  <Button className="mr-1" size="sm">
                    Cancel
                  </Button>
                </Link>
              </FormGroup>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
